// Navbar.jsx (optimized version using AuthContext)
import React from "react";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiSettings, FiMenu } from "react-icons/fi";
import AccountSwitcher from "./AccountSwitcher";
import { useAuth } from "../../providers/AuthContext";

// Default user values
const DEFAULT_USER = {
  name: "User",
  email: "",
  picture: "/default-avatar.svg",
};

const Navbar = ({ onMenuToggle, onAccountChange, isSidebarCollapsed }) => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  const handleSettings = () => {
    navigate("/settings");
  };

  // Get user data from context
  const userName = user?.name || DEFAULT_USER.name;
  const userPicture = user?.avatar_url || DEFAULT_USER.picture;

  return (
    <nav
      className={`flex w-full items-center justify-between p-4 pl-0 shadow-xs shadow-gray-300 bg-white transition-all duration-300 ${
        isSidebarCollapsed ? "pl-4" : "pl-0"
      }`}
    >
      <div className="flex items-center space-x-4">
        <button
          className="md:hidden text-gray-500 hover:text-gray-700"
          onClick={() => onMenuToggle()}
        >
          <FiMenu className="h-6 w-6" />
        </button>
        {isSidebarCollapsed && (
          <div className="flex items-center">
            <img src="/Efficia-01.svg" alt="Logo" className="h-8 mx-auto" />
          </div>
        )}
      </div>

      <div className="flex-1 mx-0 md:mx-4 hidden md:block">
        <div className="relative">
          <input
            type="text"
            placeholder="Search..."
            className="w-[50%] px-4 py-2 pl-10 focus:outline-none bg-[#EEEEEE] transition-all duration-300"
          />
          <div className="absolute left-3 top-2">
            <FiSearch className="h-6 w-6 text-blue-300" />
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-4">
        {/* <AccountSwitcher onAccountChange={onAccountChange} /> */}

        <FiSettings
          className="h-6 w-6 cursor-pointer text-black"
          onClick={handleSettings}
        />

        <div className="flex items-center space-x-2 relative group">
          <div className="flex items-center cursor-pointer">
            <span className="text-black mr-2">{userName}</span>
            {loading ? (
              <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse"></div>
            ) : (
              <img
                src={userPicture}
                alt="Profile"
                referrerPolicy="no-referrer"
                crossOrigin="anonymous"
                className="h-8 w-8 rounded-full object-cover border border-gray-200"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/default-avatar.svg";
                }}
              />
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default React.memo(Navbar);
